import { ChainId } from 'constants/constants';
import React from 'react';
import NetworkWarningModalContainer from './NetworkWarningModalContainer';
import useSelectedChain from 'hooks/useSelectedChain';
import { useDisconnect } from 'wagmi';
import { chains } from './WalletProvider/WalletProvider';

type Props = {
  btnClassName?: string;
  btnStyle?: any;
  newChainId: number;
};

const SwitchNetworkContainer: React.FC<Props> = (props) => {
  const { setChainId } = useSelectedChain();
  const { disconnect } = useDisconnect();
  const chain = chains.find((c) => c.id === props.newChainId);

  const [warningModal, setWarningModal] = React.useState<string[]>([]);

  const handleOnSelectChain = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.preventDefault();
    setChainId(props.newChainId || 1);
  };

  const tryChangeNetwork = (newChainId: ChainId) => {
    if (!newChainId) {
      console.error('Could not change networks, no new chain id given');
      return;
    }

    try {
      setChainId(newChainId);
    } catch (e) {
      disconnect();
    }
  };

  return (
    <>
      <button
        onClick={(event) => handleOnSelectChain(event)}
        type="button"
        className={props.btnClassName}
        style={props.btnStyle}
      >
        Switch to {chain?.name}
      </button>
      <NetworkWarningModalContainer
        networkNames={warningModal}
        close={() => {
          setWarningModal([]);
        }}
        change={() => {
          setWarningModal([]);
          tryChangeNetwork(props.newChainId);
        }}
      />
    </>
  );
};

export default SwitchNetworkContainer;
